import { timeDiff } from './date'

const WEEKS_TO_SHOW = 26

export function isVSMSetupPageEnabled(goLiveDate?: string | null) {
  return typeof goLiveDate === 'string'
    ? timeDiff(new Date().toISOString(), goLiveDate, 'weeks') < WEEKS_TO_SHOW
    : false
}
